import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class ModelCssLengthProperty extends ObservablePropertyDescriptorObject {

    mode = new PropertyDescriptor("auto", "模式", "基本", "string");
    value = new PropertyDescriptor(0, "值", "基本", "double");

    constructor(opts = {}) {
        super();

        if (opts === 0) {
            this.mode.value = "auto";
        }
        else if (opts === -1) {
            this.mode.value = "stretch";
        }
        else if (typeof opts === "number") {
            this.mode.value = "absolute";
            this.value.value = opts;
        }
        else {
            for (var p in opts) {
                this[p].value = opts[p];
            }
        }

        this.defineAllProperties();
    }

    getActualLength() {
        if (this.mode === "absolute") {
            return this.value;
        }
        else if (this.mode === "auto") {
            return 0;
        }
        else {
            return -1;
        }
    }

    toString() {
        if (this.mode === "auto")
            return 'auto';
        if (this.mode === "stretch")
            return "100%";
        if (this.mode === "absolute")
            return `${this.value}px`;
        if (this.mode === "percent")
            return `${this.value}%`;
    }

    toStyle() {
        return this.toString();
    }
}
